import { BlockItemType } from '@/models/Blocks/Itens/Types/block-item-type';
import { DeviceType } from "@/models/Blocks/Itens/Types/device-type";
import { TemplateItemType } from '@/models/Blocks/Itens/Types/template-item-type';
import { HistoryPosition } from '@/models/Blocks/history-position';

export class BlockItem {
    protected _type: BlockItemType;
    protected _templateType: TemplateItemType;
    protected _skeleton: boolean = false;
    protected _backgroundColor?: string;
    protected _cssClass?: string;
    protected _colorId?: string;
    protected _url?: string;
    protected _blockName?: string;
    protected _blockKey?: string;
    protected _positionKey?: string;
    protected _extraInfo: any = null;
    protected _borderColor?: string;
    protected _hasBorder: boolean = false;
//    protected _overrideBorder: boolean = false;
    protected _deviceType?: DeviceType = undefined;
    protected _source: any = undefined;
    protected _debug?: string;
    protected _mub?: string;


    public constructor(type: BlockItemType) {
        this._type = type;
        this._templateType = TemplateItemType.square;
    }

    public get type(): BlockItemType{
        return this._type;
    }
    
    public set backgroundColor(color: string|undefined){
        this._backgroundColor = color;
    }

    public get backgroundColor(): string|undefined{
        return this._backgroundColor;
    }

    public get cssClass(): string|undefined {
        return this._cssClass;
    }

    public set cssClass(value: string|undefined) {
        this._cssClass = value;
    }

    public set templateType(value: TemplateItemType){
        this._templateType = value;
    }

    public get templateType(): TemplateItemType{
        return this._templateType;
    }

    public set source(value: any){
        this._source = value;
    }

    public get source(): any{
        return this._source;
    }

    public get mubData():string|undefined{
        //return undefined;
        // return !this.blockName || !this.groupId ? undefined : JSON.stringify({
        //     t: 'product',
        //     b: this.blockName,
        //     m:{
        //         id: this.groupId
        //     }
        // });

        return this._mub;
    }

    public set mubData(value: string|undefined){
        this._mub = value;
    }

    public set blockName(value: string|undefined){
        this._blockName = value;
    }

    public get blockName():string|undefined{
        return this._blockName;
    }

    public set blockKey(value: string|undefined){
        this._blockKey = value;
    }

    public get blockKey():string|undefined{
        return this._blockKey;
    }

    public set positionKey(value: string|undefined){
        this._positionKey = value;
    }

    public get positionKey():string|undefined{
        return this._positionKey;
    }

    public set url(value: string|undefined){
        this._url = value;
    }

    public get url():string|undefined{
        /*if(this._colorId){
            return this._url + (this._url?.includes('?') ? '&' : '?') + `clr=${this._colorId}`
        }*/
        return this._url;
    }

    public get debug(): string|undefined{
        return this._debug;
    }

    public set debug(value: string|undefined) {
        this._debug = value;
    }

    public get skeleton(): boolean {
        return this._skeleton;
    }

    public set skeleton(value: boolean){
        this._skeleton = value;
    }

    public get colorId():string|undefined{
        return this._colorId;
    }

    public set colorId(value: string|undefined){
        this._colorId = value;
    }

    public get borderColor(): string|undefined {
        return this._borderColor;
    }

    public set borderColor(value: string) {
        this._borderColor = value;
    }

    public get hasBorder(): boolean {
        return this._hasBorder;
    }

    public set hasBorder(value: boolean) {
        this._hasBorder = value;
    }

    // public get overrideBorder(): boolean {
    //     return this._overrideBorder;
    // }

    // public set overrideBorder(value: boolean) {
    //     this._overrideBorder = value;
    // }

    public get extraInfo():any{
        return this._extraInfo;
    }

    public set extraInfo(value: any){
        this._extraInfo = value;
    }

    public get deviceType():DeviceType|undefined {
        return this._deviceType;
    }

    public set deviceType(value: DeviceType|undefined){
        this._deviceType = value;
    }

    public savePosition():void {
        if(this.blockKey){
            const blk: HTMLElement|null = document.querySelector(`[data-key="${this.blockKey}"]`);
            if(blk){
                let hp = HistoryPosition.getInstance(this.blockKey);
                const rec: DOMRect = blk.getBoundingClientRect();
                hp.topOffset = rec.top;
                hp.save();
            }
        }
    }

    public static strippedContent(value: string) {
        return value ? value.replace(/<\/?[^>]+>/ig, " ") : '';  
    }
}